<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('close')">
        <div
          class="modal-container bg-tertiary rounded-4xl text-gray-900"
          @click.stop
        >
          <div class="modal-header flex items-center justify-between uppercase">
            <slot name="header ">
              <div>Select Token</div>
              <div @click="$emit('close')" class="cursor-pointer text-lg">
                <img src="@/assets/images/x.svg" alt="" />
              </div>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <span class="text-xl w-full border">
                <input
                  type="text"
                  style="border-color: #b2aea8"
                  class="w-full py-3 px-3 rounded-lg bg-tertiary border rounded focus:outline-none"
                  placeholder="Search Token"
                  v-model="search"
                />
                <div class="mt-4 nfts overflow-auto z-0 flex flex-col" style="">
                  <div v-for="(token, i) in filteredTokens" :key="i" class="">
                    <div
                      class="flex space-x-4 items-center mt-6 cursor-pointer hover:bg-gray-900 hover:bg-opacity-25 py-4 px-2 rounded-lg"
                      @click="pick(token.symbol, $event)"
                    >
                      <i
                        class="bg-blue-500 rounded-full bg-white h-16 w-16 mr-4 flex items-center justify-center shadow-sm"
                        ><img
                          :src="token.logo_url"
                          alt=""
                          class="rounded-full object-cover"
                      /></i>
                      <!-- <img :src="token.logo_url" alt="" class="h-10" /> -->
                      <div>{{ token.symbol }}</div>
                    </div>
                  </div>
                </div>
              </span>
            </slot>
          </div>

          <div class="modal-footer z-50">
            <slot name="footer">
              <div class="">
                <button
                  @click="select"
                  class="w-full text-center uppercase font-primary font-bold leading-none text-2xl inline-block rounded-lg py-4 px-5 text-brown hover:text-white bg-secondary hover:bg-blue-900 hover:bg-opacity-70 transition duration-0 focus:outline-none"
                >
                  Select
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const axios = require("axios").default;

export default {
  name: "SelectTokenModal",
  components: {},
  props: { userAction: String },
  data: function () {
    return {
      nfts: [],
      checkedNfts: [],
      erc1155values: {},
      erc1155Availablevalues: {},
      search: "",
      tokens: [],
      selected: false,
    };
  },
  methods: {
    getTokens: async function () {
      var pools = await axios.get(
        "https://api.nft20.io/pools?perPage=100&page=1"
      );

      this.tokens = pools.data.data;

      this.tokens.push(
        {
          symbol: "WETH",
          name: "WETH",
        },
        {
          symbol: "MUSE",
          name: "MUSE",
        }
      );
    },
    select: async function () {
      this.$emit("close");
    },
    pick: async function (token, ev) {
      console.log(ev);
      if (this.userAction == "deposit") {
        this.selected = !this.selected;
        this.paySelected(token);
      } else if (this.userAction == "withdraw") {
        alert("withdraw");
      }
    },
    paySelected: async function (token) {
      this.$store.commit("setTokenSelected", {
        type: "token", //project nfts address
        token: token,
      });
    },
    // withdrawAction: async function () {
    //   this.$store.commit("setCasWithdraw", []);
    // },
  },
  beforeMount: async function () {},

  mounted: async function () {
    await this.getTokens();

    console.log("casIn ", this.$store.state.casDeposit);
  },
  watch: {},
  computed: {
    project: function () {},
    filteredTokens() {
      return this.tokens.filter((asset) => {
        return (
          asset.symbol.toLowerCase().includes(this.search.toLowerCase()) ||
          asset.name.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
  },
  created: async function () {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::placeholder {
  /* padding: 0px 1rem; */
  /* maybe remove this */
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.input {
  background-color: #afaca2;
  cursor: pointer;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  background-color: #afaca2;
  color: white;
  border-radius: 6px;
  text-align: center;
}
input[type="number"]:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.nfts {
  max-height: calc(340px);
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  max-height: calc(100vh - 80px);
  /* overflow-y: hidden; */
  width: 40%;
  margin: 0px auto;
  padding: 30px 30px;
  /* background-color: #fff; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
@media (max-width: 768px) {
  .modal-container {
    max-height: calc(100vh - 80px);
    /* overflow-y: auto; */
    width: 80%;
  }
}
</style>